
import { isInDisplayCriteria, addOddsDiff, matchCompare, updateAllUpCalCookies, diffAllUpSelection, checkINPLAYandOFMPool } from '../common';
import { getQueryVariables } from '../../../Data/DataQuery';
import { getDisplayMatches } from '../../useGetMatchList/common';
import { trimTournament, getQueryTorunIds, getQueryMatchIdForDateTab, getQueryDateRange, isTournamentPage } from '../../../Common/Common';
import { updateMatchList } from '../parseUpdMatchPool'
import { updatePoolInfo , updatePoolOdds} from './updateMatchPool'
import { parseUpdMatchPool } from '../parseUpdMatchPool'

export const parseUpdMatchPoolV2 = async (message, topicInfo, contentRef,loadMatchQuery, option) =>{
    if(!topicInfo.oddsUpd){
        parseUpdMatchPool(message, topicInfo, contentRef,loadMatchQuery, option)
        return
    }

    let topicMatchID = topicInfo.matchid;
    let topicPoolID =topicInfo.poolid;
    const isAllOddsPage = contentRef.current.config.AllOddsPages.includes(contentRef.current.page)
    const isTournPage = isTournamentPage(contentRef.current.page)
    let match = contentRef.current.matchData?.matches.find(x => x.id===topicMatchID);
    if(isAllOddsPage && ['TQL','CHP'].includes(topicInfo.bettype?.toUpperCase())){
        match = contentRef.current.matchData?.matches.find(x => x.tournament.id===topicInfo.tournamentid)
    }
    let currentPool = null;
    if(match){
        currentPool = match.foPools.find(x => x.id == topicPoolID)
    }

    if(!match || !currentPool) return
    let newPool = updatePoolOdds(currentPool, message)
    addOddsDiff(contentRef, match, currentPool, newPool, option)
    currentPool.lines = newPool.lines
    updateAllUpCalCookies(message, newPool)
}